export default __webpack_public_path__ + "static/B0320-af0fb9683ebf13aea5ed37029a3871cd.png";